import { Injectable } from '@angular/core';
import { CustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-type.enum';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';

@Injectable({
    providedIn: 'root'
})
export class CustomFormsHelpersService {

    constructor() { }

    getOptionId = (question: CustomFormQuestionDisplayDTO<any>, optionIndex: number) => {
        return `${question.questionID}_${optionIndex}`
    }

    getOptionIndexFromId = (optionId?: string | null) => {
        return optionId ? parseInt(optionId.split('_')[1]) : -1;
    }

    getCustomFormTypeLabel = (formType?: CustomFormType) => {
        if (formType === undefined || formType === null) return '';

        return formType === CustomFormType.INDIVIDUAL ? 'Individual' : 'Supervisor';
    }  

    // In order for Deserialization to work in .Net Core 8 the $type property must be the first property in the object
    // User this function to create Custom Form Questions to garentee the $type property is the first property
    createCustomFormQuestion<T extends any>(question: CustomFormQuestionDisplayDTO<T>): CustomFormQuestionDisplayDTO<T> {
        const { $type, ...rest } = question;
        
        return {
            $type: $type,
            ...rest
        }
    }
}
